/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Slot_Generation_Booked_KeptInputs */

const en_job_form_slot_generation_booked_kept = /** @type {(inputs: Job_Form_Slot_Generation_Booked_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`booked – will be kept`)
};

const de_job_form_slot_generation_booked_kept = /** @type {(inputs: Job_Form_Slot_Generation_Booked_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gebucht – bleibt bestehen`)
};

/**
* | output |
* | --- |
* | "booked – will be kept" |
*
* @param {Job_Form_Slot_Generation_Booked_KeptInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_booked_kept = /** @type {((inputs?: Job_Form_Slot_Generation_Booked_KeptInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_Booked_KeptInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_booked_kept(inputs)
	return en_job_form_slot_generation_booked_kept(inputs)
});